const initialState = {
    request: {},
    response: {},
    profilePullSuccess: false,
    ecTokenStatus: '',
    ecFlowType: null,
    tokenRevalidated: false,
    ecTokenMsg: '',
    ecTokenCategdesc: null,
    isECSmartcart: false,
    isECSmartCartLoaded: false,
    isECSmartCartEnabled: false,
    isnoniphoneapp:"Y",
    isTVQualified: false,
    mixmatch2: false,
    isMvAppFlow: false,
    isNCMVAppFlow: false,
    isClassicAffinityFlow: false,
    pegaNoRecReason: '',
    intCMP:"",
    mvaECPerks: null
};

function validateSignIn(state = initialState, action) {
    switch (action.type) {
        case "INITAL_SIGNIN":
            return Object.assign({}, state, {
                request: action.value,
            });
        case "AFTER_SIGNIN":
            var isTVQualified = false;
            let lqServices = action.value && action.value.services ? action.value.services : [];
            sessionStorage.setItem('existingCustomerLogin', true)
            if (action.value && action.value.customerContactInfo && action.value.customerContactInfo.mtn) {
                sessionStorage.setItem("fiosCustomSupport", action.value.customerContactInfo.mtn);
                sessionStorage.getItem("fiosRefMob", action.value.customerContactInfo.mtn)
            }
            if (action.value && action.value.state) {
                sessionStorage.setItem('fiosRefState', action.value.state);
            }
            if (action.value && action.value.mon) {
                sessionStorage.setItem('fiosReferralMON', action.value.mon);
            }
            if (lqServices.length > 0) {
                for (let i = 0; i < lqServices.length; i++) {
                    if (lqServices[i] && lqServices[i].servicename) {
                        if (lqServices[i].servicename === 'Video' && lqServices[i].qualified === 'Y') {
                            isTVQualified = true;
                        }
                    }
                }
            }
            return Object.assign({}, state, {
                response: action.value,
                isTVQualified: isTVQualified,
                pegaNoRecReason: action.value && action.value.reasonForNoProposition ? action.value.reasonForNoProposition : '' 
            });
        case "VEC_FLOW_ROUTE":
            let signInResponse = Object.assign({}, state.response, {
                flowRoute: action.value
            });
            return Object.assign({}, state, {
                response: signInResponse
            });
        case "PROFILE_SUCCESS":
            return Object.assign({}, state, {
                profilePullSuccess: action.value,
            });

        case 'SET_MVAPERKS':
            return Object.assign({}, state, {
                mvaECPerks: action.value
            })
        case "EC_SMARTCART":
            return Object.assign({}, state, {
                isECSmartcart: action.value,
            });
        case "Classic_AffinityFlow":
                return Object.assign({}, state, {
                    isClassicAffinityFlow: action.value,
                });
        case "EC_SMARTCART_LOADED":
            return Object.assign({}, state, {
                isECSmartCartLoaded: action.value,
            });
        case "EC_SMARTCART_ENABLED":
            return Object.assign({}, state, {
                isECSmartCartEnabled: action.value,
            });
        case "ECUpdateCouponFlowStatus":
            return Object.assign({}, state, {
                ecTokenStatus: action.value
            })
        case "ECupdateCouponFlowType":
            return Object.assign({}, state, {
                ecFlowType: action.value
            })
        case "EC_TOKEN_REVALIDATION":
            return Object.assign({}, state, {
                tokenRevalidated: action.value
            })
        case "ECUpdateCouponFlowMsg":
            return Object.assign({}, state, {
                ecTokenMsg: action.value
            })
        case "ECUpdateCouponCategDesc":
            return Object.assign({}, state, {
                ecTokenCategdesc: action.value
            })
        case 'UPDATE_EC_MIXMATCH2':
            return Object.assign({}, state, {
                mixmatch2: action.value && action.value === 'y'
            })
        case 'EC_MVAPP_FLOW': 
            return Object.assign({}, state, {
                isMvAppFlow: action.value
            })
        case 'EC_MVAPP_FLOW_TITLE_CHANGE': 
           return Object.assign({}, state, {
                intCMP: action.value
            })
        case 'UPDATE_ISIPHONE_APP':
            return Object.assign({}, state, {
                isnoniphoneapp : action.value
        })
        case 'NC_MVAPP_FLOW': 
            return Object.assign({}, state, {
                isNCMVAppFlow: action.value
        })
        default:
            return state
    }
}
export default validateSignIn;